import type { enTainan } from './en.tainan';

export const caTainan: typeof enTainan = {
  tainan: {
    mapNames: { tainan: 'Tainan' },
    zones: {
      tn_city: 'Barri antic de Tainan',
      tn_station: 'Estació d’alta velocitat',
      tn_chihkan: 'Torre Chihkan',
      tn_shennong: 'Carrer Shennong',
      tn_anping: 'Anping',
      tn_market: 'Mercat del carrer Guohua',
      tn_confucius: 'Temple de Confuci',
      tn_canal: 'Canal d’Anping',
    },
    objects: {
      tn_hsr: 'Estació d’alta velocitat · Tainan',
      tn_shuttle: 'Parada de la llançadora (H31)',
      tn_chihkan: 'Torre Chihkan',
      tn_turtles: 'Tortugues de pedra',
      tn_lanterns: 'Taller de fanalets',
      tn_zeelandia: 'Fort Zeelandia',
      tn_treehouse: 'Arbre-casa d’Anping',
      tn_shrimp: 'Parada de galetes de gamba',
      tn_candied: 'Botiga de fruita confitada',
      tn_boatRide: 'Passeig en barca pel canal',
      tn_beefSoup: 'Parada de sopa de vedella',
      tn_danzai: 'Parada de fideus danzai',
      tn_coffin: 'Parada de pa-taüt',
      tn_confucius: 'Sala del Temple de Confuci',
    },
    npc: {
      tn_soupGranny: 'Àvia de la sopa de vedella',
      tn_fortGuide: 'Guia del fort',
      tn_scholar: 'Estudiant confucià',
      tn_crackerLady: 'Venedora de galetes de gamba',
      tn_candiedAunt: 'Tieta de la fruita confitada',
      tn_fisher: 'Pescador del canal',
      tn_kid1: 'Nen amb estel',
      tn_kid2: 'Nena amb quadern',
      tn_lanternArtist: 'Artista de fanalets',
      tn_shuttleDriver: 'Conductor de la llançadora',
      tn_cyclist: 'Ciclista',
      tn_grandpa: 'Avi dels escacs',
      tn_boatman: 'Barquer',
    },
    items: {},

    shuttle: {
      text: 'L’estació d’alta velocitat de Tainan és a Guiren, a 10 km del barri antic. La llançadora gratuïta H31 va al centre cada 20 minuts: mitja hora de viatge.',
      ask: '🚌 Pregunta al conductor (anglès)',
      q: 'Com preguntes si aquest bus va al centre?',
      // English practice
      a: ['Excuse me, does this bus go to the city centre?', 'Bus! City! Now!', 'You drive me downtown.'],
      right: '«Yes! Chihkan Tower is the fourth stop. Hold on tight!»',
      wrong: 'El conductor arrufa les celles. Prova una pregunta més educada: comença per «Excuse me…».',
    },
    chihkan: {
      text: 'La Torre Chihkan (赤崁樓) s’alça sobre el fort Provintia, construït pels holandesos el 1653. La dinastia Qing hi va afegir després aquests dos pavellons: el temple del Déu del Mar i el pavelló Wenchang dels estudiants.',
      learn: '🏯 Qui va construir el fort? (anglès)',
      q: 'Who built the first fort here?',
      // English practice
      a: ['The Dutch, in 1653.', 'The Romans, in 100.', 'The Japanese, in 1950.'],
      right: 'Exacte! Els holandesos van governar Tainan 38 anys, fins que Koxinga (鄭成功) els va expulsar el 1662.',
      wrong: 'Mira la base de maó: té 370 anys…',
    },
    turtles: {
      text: 'Nou tortugues de pedra (贔屭) carreguen esteles altes al llom: un regal de l’emperador Qianlong el 1788. Diu la llegenda que una va caure al port i la van haver de substituir.',
      count: '🐢 Compta les tortugues (anglès)',
      q: 'How many turtles were there at first?',
      // English practice: number words
      a: ['Nine.', 'Seven.', 'Twelve.'],
      right: 'Nou! Una tortuga amb una estela al llom vol dir llarga vida i bones notícies.',
      wrong: 'Torna a comptar, amb els dits, en anglès…',
    },
    confucius: {
      text: 'El Temple de Confuci (孔廟) es va fundar el 1665: el primer de Taiwan. Sobre la porta penja la placa 全臺首學, «la primera escola de tot Taiwan». Els estudiants encara hi vénen abans dels exàmens.',
      learn: '📜 Llegeix la placa (anglès)',
      q: 'What does 全臺首學 mean?',
      // English practice
      a: ['The first school of all Taiwan.', 'The biggest market of Taiwan.', 'No running in the temple.'],
      right: 'Sí! «First» (首) i «school» (學). Fas una reverència al mestre, com els estudiants.',
      wrong: 'Pista: això era una escola, no un mercat…',
    },
    zeelandia: {
      text: 'El fort Zeelandia (安平古堡) va ser el quarter general holandès a Taiwan, construït el 1624. El 1662 Koxinga el va assetjar nou mesos i els holandesos van marxar. Només queden originals alguns murs de maó vermell; la torre blanca és del 1930.',
      learn: '🏰 Quin país? (anglès)',
      q: 'Which country built Fort Zeelandia?',
      // English practice
      a: ['The Netherlands.', 'Spain.', 'Australia.'],
      right: 'Correcte, els holandesos! Els seus maons van venir des de Java com a llast dels vaixells.',
      wrong: 'La bandera de la torre té franges vermelles, blanques i blaves…',
    },
    treehouse: {
      text: 'L’Arbre-casa d’Anping (安平樹屋) va ser un magatzem de la firma britànica Tait & Co. Quan el van abandonar, un banià va créixer sobre els murs, per les finestres i pel sostre: ara l’arbre ÉS la casa.',
      learn: '🌳 Descriu-lo (anglès)',
      q: 'What happened to the warehouse?',
      // English practice: past tense
      a: ['A tree grew over it.', 'A tree will grow over it.', 'A tree is eating my lunch.'],
      right: '«Grew», el passat de «grow». Les arrels semblen cortines de corda!',
      wrong: 'Va passar fa molt de temps. Quina resposta és en passat?',
    },
    lanterns: {
      text: 'La fanalera del carrer Shennong pinta fanalets de paper a mà: vermells per a la sort, grocs per a la riquesa, i un amb un drac per al Festival dels Fanalets.',
      paint: '🏮 Tria un color (anglès)',
      q: 'The artist holds up a lantern the colour of a ripe tomato. What colour is it?',
      // English practice: colours
      a: ['Red.', 'Blue.', 'Green.'],
      right: 'Red! Hi escriu 福 (bona fortuna) i el penja sobre el carrer per a tu.',
      wrong: 'Mira els tomàquets de la taula per a la pista…',
      closed: 'La persiana és abaixada; la fanalera comença a treballar a partir de les tres de la tarda.',
    },
    boat: {
      text: 'Una barca turística llisca pel canal d’Anping, sota els ponts i cap al port vell. El patró explica històries dels vaixells de sal que feien servir aquestes aigües fa cent anys.',
      ride: '🚤 Compra un bitllet (anglès)',
      price: 50,
      poor: 'El bitllet de la barca costa 50 monedes. Torna amb més diners!',
      q: 'How do you ask for a ticket?',
      // English practice
      a: ['One ticket for the boat tour, please.', 'Boat. Me. Go.', 'Give ticket boat now.'],
      right: 'Trenta minuts a l’aigua: martinets a la riba, la torre del fort al fons, una brisa fresca. Preciós!',
      wrong: 'El barquer somriu amb paciència. Prova amb «…please».',
      closed: 'L’última barca ja ha sortit per avui. Els passeigs van de nou a sis.',
    },
    beefSoup: {
      vendor: 'Fresh beef soup! The beef is sliced thin and cooked in the hot broth right in your bowl. One bowl?',
      ok: 'One bowl of beef soup with rice, please.',
      bad: ['Beef. Bowl. Hurry.', 'I want beef soup, but no beef and no soup.'],
      done: 'La vedella és rosada i tendra, el brou dolç amb gingebre. L’àvia hi afegeix una cullerada d’arròs de franc. «Menja a poc a poc!»',
      price: 45,
    },
    danzai: {
      vendor: 'Danzai noodles — the Tainan way since 1895! A small bowl with a shrimp on top. Would you like one?',
      ok: 'Yes, please. One bowl of danzai noodles.',
      bad: ['Noodle give.', 'I eat all noodles, you pay.'],
      done: 'Un bol petit: fideus, carn picada, una gamba entera i una gota de vinagre negre. Petit, però perfecte.',
      price: 40,
    },
    coffin: {
      vendor: 'Coffin bread! Don’t worry — it’s just a box of fried toast filled with creamy chicken stew. Hungry?',
      ok: 'Could I have one coffin bread, please?',
      bad: ['Coffin! Scary!', 'Toast box me want.'],
      done: 'Cruixent per fora, cremós per dins. El nom ve de la forma: una capsa de pa amb tapa. Nyam!',
      price: 35,
    },
    shrimp: {
      vendor: 'Anping shrimp crackers, fried this morning! Light as air. Original or spicy?',
      ok: 'One bag of the original crackers, please.',
      bad: ['Crackers. All. Mine.', 'Spicy no original yes give.'],
      done: 'Una bossa enorme i rosada, cruixent i dolça-salada. La venedora hi posa una de més «per al camí».',
      price: 30,
    },
    candied: {
      vendor: 'Candied fruit from Anping: plums, mango, olives, tomatoes with ginger… Try a sample?',
      ok: 'Could I try the candied mango, please?',
      bad: ['Candy sample free all.', 'Me eat jar.'],
      done: 'Dolç, àcid i una mica salat. La tieta embolica una bosseta de mango i unes prunes per al tren.',
      price: 35,
    },
    closedMorning: 'L’olla és buida! La sopa de vedella és un esmorzar: vine abans de les dues de la tarda.',

    talk: {
      tn_soupGranny: [
        'Fa quaranta anys que venc sopa de vedella aquí. La carn ve de Shanhua, fresca cada matinada.',
        'English practice: “Would you like rice with that?” — “Yes, please!”',
        'A Tainan mengem dolç. Fins i tot la sopa és una mica dolça!',
      ],
      tn_fortGuide: [
        'Aquests maons vermells van venir de Java com a llast dels vaixells holandesos. Quatre-cents anys!',
        'English practice: “Where are you from?” — “I’m from Taiwan.”',
        'Des de la torre es veu el mar: el 1624 l’aigua arribava fins a aquest mur.',
      ],
      tn_scholar: [
        'Els estudiants deixen l’entrada de l’examen a l’altar per tenir sort. Jo hi vaig deixar la meva la setmana passada.',
        'English practice: “Good luck on your exam!” — “Thank you!”',
        'Confuci deia: aprendre sense pensar és inútil; pensar sense aprendre és perillós.',
      ],
      tn_crackerLady: [
        'Les galetes de gamba es fan amb gamba de debò i tapioca. Mira com s’inflen a l’oli!',
        'English practice: “How much is one bag?” — “Thirty dollars.”',
      ],
      tn_candiedAunt: [
        'Primer assequem la fruita al sol i després la banyem en sucre i sal. Tres setmanes per a una bona pruna!',
        'English practice: “Can I try one?” — “Of course, here you are.”',
      ],
      tn_fisher: [
        'El canal es va excavar el 1926 per portar peix i sal a la ciutat. Ara porta turistes!',
        'English practice: “Did you catch anything?” — “Not yet… the fish are sleeping.”',
        'Fixa’t en els martinets. Ells saben on són els peixos.',
      ],
      tn_kid1: [
        'El meu estel és una oreneta! El vent del canal és el millor de Tainan.',
        'English practice: “Look! It’s flying!” — “Wow!”',
      ],
      tn_kid2: [
        'Estic dibuixant les tortugues. Nou tortugues: una, dues, tres… la quarta té el nas trencat.',
        'English practice: “What are you drawing?” — “I’m drawing a turtle.”',
      ],
      tn_lanternArtist: [
        'Tots els fanalets d’aquest carrer estan pintats a mà. El del drac em va costar tres dies.',
        'English practice: “What colour do you like?” — “I like red.”',
        'De nit el carrer Shennong es torna daurat. Queda’t fins que s’encenguin els fanalets!',
      ],
      tn_shuttleDriver: [
        'H31 al centre, gratis amb el bitllet d’alta velocitat. El pròxim surt en deu minuts.',
        'English practice: “Does this bus stop at Chihkan Tower?” — “Yes, the fourth stop.”',
      ],
      tn_cyclist: [
        'Tainan és plana, perfecta per a la bici. El camí del canal arriba fins al mar.',
        'English practice: “Turn left at the bridge.”',
      ],
      tn_grandpa: [
        'Escacs xinesos. El general no pot sortir del seu palau… com jo, que no surto mai de Tainan!',
        'English practice: “Your move.” — “Hmm… let me think.”',
        'Quan era petit, pel canal encara passaven velers carregats de sal.',
      ],
      tn_boatman: [
        'El passeig passa sota cinc ponts. Ajup el cap al tercer!',
        'English practice: “Please sit down and hold the rail.”',
      ],
    },
  },
};
